/**
 * **HUD の器**（Issue #523）。テーマの HUD を舞台に置くだけ。
 *
 * 盤（`FieldLayer.js`）は平面の紙に canvas で描くが、**HUD は盤の外なので舞台のピクセルに DOM で**
 * 描く（ユーザー判断 2026-09-24）。平面に乗らない＝遠近が要らず、逆に要るのがガラス風のぼかし
 * （`backdrop-filter`）・文字の省略（`…`）で、canvas だと自前で書くことになるため。
 *
 * ここが持つのは置き場だけ。**何を答えるか**は `core/hud`（口の名前・文字の下限・fallback）、
 * **どこに何があるか・どう描くか**はテーマ（`themes/<name>/drawHud.js`）。
 */
import { hudValues } from '../core/hud';
import { cssVars, resolveStyle } from '../core/theme';

/**
 * @param theme `core/theme::toTheme()` を通したテーマ
 * @param scene そのフレームの素材（読むのは `scene.hud`）
 * @param view 盤の見え方（HUD が「盤に掛からない場所に置く」のに使う）
 * @param canvas 舞台の大きさ
 * @param config 設定（`config.hud` がテーマの HUD の設定を上書きする）
 * @param fx 演出が当てる作用（`core/hud::foldHudFx`。Issue #542）。テーマの HUD へそのまま渡す
 */
export default function HudLayer({ theme, scene, view, canvas, config = null, fx = null }) {
  if (!scene?.hud || config?.hud?.show === false) return null;
  const options = { ...theme.hud.options, ...(config?.hud ?? {}) };
  /*
   * **テーマの見た目の値**（Issue #523）。宣言は `theme.schema` で、**全部の層に同じものが届く**。
   * `css` を持つ宣言は**カスタムプロパティとして root に当てる**ので、
   * テーマの CSS は `var(--…)` を書くだけでよい（ぼかし・`clip-path`・縁取りを捨てずに済む）。
   */
  const style = resolveStyle(theme, config?.style);
  const values = hudValues(scene.hud);
  const anchors = theme.hud.anchors({ canvas, view, options, style });
  const Hud = theme.hud.Component;
  return (
    <div className="de-layer de-hud" data-layer="hud" data-theme={theme.name} style={cssVars(theme.schema, style)}>
      <Hud values={values} anchors={anchors} options={options} style={style} fx={fx ?? {}} canvas={canvas} />
    </div>
  );
}
